import { ABaseModel } from '@pperform/pp-data-mappers';

/* eslint-disable camelcase */
export interface EvaluateShipmentPayloadDTO {
  shipment_pk: number;
  cms_reference: string;
}

export class EvaluateShipmentRespDTO extends ABaseModel {
  isShipmentEligibleForReturn = false;

  nonEligibleLineItems: string[] = [];
}
